export default "__VITE_ASSET__9bacc7a8__"